import { css } from '@emotion/react';
import { noop } from 'lodash-es';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';
import { NakedButton } from '@frontend/design-system';

type EventButtonProps = {
  isActive: boolean;
  children: React.ReactNode;
  onClick: () => void;
} & Omit<CommonHTMLButtonAttributes, 'onClick'>;

export const EventButton = ({ isActive, children, onClick, disabled = false, ...rest }: EventButtonProps) => {
  return (
    <NakedButton
      {...rest}
      disabled={disabled}
      css={buttonStyles(isActive, disabled)}
      onClick={disabled ? noop : onClick}
    >
      {children}
    </NakedButton>
  );
};

const buttonStyles = (isActive: boolean, disabled: boolean) =>
  css({
    cursor: disabled ? 'not-allowed' : 'pointer',
    padding: theme.spacing(1),
    borderRadius: theme.borderRadius.small,
    border: `1px solid ${isActive ? theme.colors.primary50 : theme.colors.neutral20}`,
    color: isActive ? theme.colors.primary50 : theme.colors.neutral50,
    backgroundColor: disabled ? theme.colors.neutral5 : isActive ? theme.colors.primary10 : theme.colors.white,
  });
